/* AQQA Studio • Lightweight, dependency-free storefront interactions */
(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const q = (selector, scope = document) => scope.querySelector(selector);
  const qa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const config = window.AQQA || {};
  const root = (config.root || '/').replace(/\/$/, '') + '/';
  const endpoint = suffix => root + suffix.replace(/^\//, '');
  const currency = config.currency || 'TRY';
  const money = cents => {
    try { return new Intl.NumberFormat('tr-TR', {style: 'currency', currency}).format((Number(cents) || 0) / 100); }
    catch { return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + currency; }
  };
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character]));

  const overlay = q('[data-menu-overlay]');
  const drawer = q('[data-cart-drawer]');
  const mobileMenu = q('[data-mobile-nav]');
  const menuButton = q('[data-mobile-toggle]');
  const searchPanel = q('[data-search-panel]');
  let pending = false;
  let lastFocus = null;
  function lockUI() {
    const shown = drawer?.classList.contains('is-open') || mobileMenu?.classList.contains('is-open');
    if (overlay) overlay.hidden = !shown;
    document.body.classList.toggle('aqqa-lock', !!shown);
  }
  function closeMenu() {
    mobileMenu?.classList.remove('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'true');
    menuButton?.setAttribute('aria-expanded', 'false');
    lockUI();
  }
  function openMenu() {
    closeDrawer();
    lastFocus = document.activeElement;
    mobileMenu?.classList.add('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'false');
    menuButton?.setAttribute('aria-expanded', 'true');
    lockUI();
    q('[data-mobile-close]')?.focus();
  }
  function closeDrawer() {
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    lockUI();
  }
  async function openDrawer() {
    closeMenu();
    lastFocus = document.activeElement;
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    lockUI();
    q('[data-cart-close]')?.focus();
    await refreshCart();
  }
  menuButton?.addEventListener('click', openMenu);
  q('[data-mobile-close]')?.addEventListener('click', () => { closeMenu(); lastFocus?.focus?.(); });
  qa('[data-cart-open]').forEach(button => button.addEventListener('click', openDrawer));
  q('[data-cart-close]')?.addEventListener('click', () => { closeDrawer(); lastFocus?.focus?.(); });
  overlay?.addEventListener('click', () => { closeDrawer(); closeMenu(); lastFocus?.focus?.(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeDrawer(); closeMenu();
      if (searchPanel && !searchPanel.hidden) searchPanel.hidden = true;
      lastFocus?.focus?.();
    }
  });
  q('[data-search-toggle]')?.addEventListener('click', () => {
    if (!searchPanel) return;
    searchPanel.hidden = !searchPanel.hidden;
    if (!searchPanel.hidden) q('input[type="search"]', searchPanel)?.focus();
  });
  q('[data-search-close]')?.addEventListener('click', () => { if (searchPanel) searchPanel.hidden = true; });

  function renderCart(cart) {
    qa('[data-cart-number]').forEach(el => { el.textContent = String(cart.item_count); });
    qa('[data-cart-count]').forEach(el => { el.textContent = `(${cart.item_count})`; });
    const container = q('[data-cart-content]');
    if (!container) return;
    if (!cart.items.length) {
      container.innerHTML = `<div class="drawer-empty"><p>Sepetiniz henüz boş.</p><a class="aqqa-text-link" href="${endpoint('collections/all')}">KOLEKSİYONU KEŞFET →</a></div>`;
      return;
    }
    container.innerHTML = `<div class="drawer-items">${cart.items.map((item, index) => {
      const image = item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy" width="96" height="128">` : '';
      const title = escapeHTML(item.product_title);
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? escapeHTML(item.variant_title) : '';
      return `<div class="drawer-item"><a href="${escapeHTML(item.url)}">${image}</a><div class="drawer-item__text"><a class="drawer-item__name" href="${escapeHTML(item.url)}">${title}</a><span class="drawer-item__meta">${variant}</span><strong>${money(item.final_line_price)}</strong><div class="drawer-item__actions"><div class="drawer-item__qty"><button type="button" data-line="${index + 1}" data-quantity="${item.quantity - 1}" aria-label="Azalt">−</button><span>${item.quantity}</span><button type="button" data-line="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Artır">+</button></div><button type="button" data-line="${index + 1}" data-quantity="0">KALDIR</button></div></div></div>`;
    }).join('')}</div><div class="drawer-totals"><span>ARA TOPLAM</span><span>${money(cart.total_price)}</span></div><p style="font-size:11px;color:#777">Kargo ve vergiler ödeme adımında hesaplanır.</p>`;
    qa('[data-line]', container).forEach(button => button.addEventListener('click', () => changeCart(Number(button.dataset.line), Number(button.dataset.quantity))));
  }
  async function refreshCart() {
    try {
      const response = await fetch(endpoint('cart.js'), {credentials: 'same-origin', headers: {'Accept':'application/json'}});
      if (!response.ok) throw new Error('Sepet yüklenemedi');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    } catch (error) {
      const content = q('[data-cart-content]');
      if (content) content.innerHTML = `<p>Sepet şu anda yüklenemiyor.</p><a class="aqqa-text-link" href="${endpoint('cart')}">SEPETE GİT →</a>`;
    }
  }
  async function changeCart(line, quantity) {
    if (pending) return;
    pending = true;
    drawer?.classList.add('drawer-loading');
    try {
      const response = await fetch(endpoint('cart/change.js'), {
        method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
        credentials: 'same-origin', body: JSON.stringify({line, quantity})
      });
      if (!response.ok) throw new Error('Sepet güncellenemedi');
      renderCart(await response.json());
    } catch { await refreshCart(); }
    finally {pending = false;drawer?.classList.remove('drawer-loading');}
  }

  async function addQuickVariant(variantId) {
    const response = await fetch(endpoint('cart/add.js'), {
      method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
      credentials: 'same-origin', body: JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Sepete eklenemedi.');
    return result;
  }
  async function showQuickCart() {
    const cart = await refreshCart();
    const content = q('[data-quick-cart-content]');
    const panel = q('[data-quick-cart]');
    const shade = q('[data-quick-cart-shade]');
    if (!panel || !content) return openDrawer();
    if (cart) {
      content.innerHTML = cart.items.map(item => `<div class="aqqa-mini-cart-item"><a href="${escapeHTML(item.url)}">${item.image ? `<img src="${escapeHTML(item.image)}" alt="" width="100" height="110">` : ''}</a><div><a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.product_title)}</strong></a><small>${escapeHTML(item.variant_title === 'Default Title' ? '' : (item.variant_title || ''))}</small><small>Adet: ${item.quantity}</small></div><b>${money(item.final_line_price)}</b></div>`).join('') + `<div class="aqqa-mini-cart-total"><span>Toplam ürün ${cart.item_count}</span><strong>Ara Toplam ${money(cart.total_price)}</strong></div>`;
    }
    closeDrawer();
    if (shade) shade.hidden = false;
    panel.hidden = false;
    document.body.classList.add('aqqa-lock');
    q('[data-quick-cart-close]', panel)?.focus();
  }
  function closeQuickCart() {
    const panel = q('[data-quick-cart]');
    if (panel) panel.hidden = true;
    const shade = q('[data-quick-cart-shade]');
    if (shade) shade.hidden = true;
    document.body.classList.remove('aqqa-lock');
  }
  qa('[data-quick-cart-close]').forEach(el => el.addEventListener('click', closeQuickCart));
  q('[data-quick-cart-shade]')?.addEventListener('click', closeQuickCart);
  document.addEventListener('keydown', e => {if (e.key === 'Escape') closeQuickCart();});
  window.AQQACart = {addQuickVariant,showQuickCart,refreshCart,openDrawer,closeQuickCart,money};

  // Collection filter layout & native Shopify collection filters
  q('[data-filter-toggle]')?.addEventListener('click', event => {
    const panel = q('[data-filter-panel]');
    const parent = panel?.parentElement;
    if (!parent) return;
    const open = parent.classList.toggle('filters-open');
    event.currentTarget.setAttribute('aria-expanded', String(open));
  });
  qa('[data-auto-submit]').forEach(select => select.addEventListener('change', () => select.form?.submit()));
  qa('[data-qty-minus]').forEach(button => button.addEventListener('click', () => {
    const input = q('input[name="quantity"]', button.closest('.product-info__actions'));
    if (input) input.value = String(Math.max(1, (parseInt(input.value, 10) || 1) - 1));
  }));
  qa('[data-qty-plus]').forEach(button => button.addEventListener('click', () => {
    const input = q('input[name="quantity"]', button.closest('.product-info__actions'));
    if (input) input.value = String((parseInt(input.value, 10) || 1) + 1);
  }));

  // Variant resolution respects all option axes (number, color, material, etc.)
  function initializeProductSections() {
    qa('[data-product-section]').forEach(section => {
      if (section.dataset.aqqaBaseInitialized) return;
      section.dataset.aqqaBaseInitialized = 'true';
    const form = q('.aqqa-product-form', section);
    const variantsNode = q('[data-product-variants]', section);
    if (!form || !variantsNode) return;
    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch { return; }
    const inputs = qa('[data-option-index]', section);
    try {
      const desiredColor = new URL(window.location.href).searchParams.get('aqqa_color');
      const initialColorIndex = Number(section.dataset.colorOptionIndex);
      if(desiredColor && initialColorIndex>=0 && inputs[initialColorIndex]) {
        const matching = qa('input[type="radio"]',inputs[initialColorIndex]).find(input=>input.value.toLocaleLowerCase('tr-TR')===desiredColor.toLocaleLowerCase('tr-TR'));
        if(matching)matching.checked=true;
      }
    } catch { /* preview mode */ }
    const price = q('[data-product-price]', section);
    const idField = q('[data-variant-id]', form);
    const addButton = q('[data-add-button]', form);
    const label = q('[data-add-label]', form);
    const availability = q('[data-product-availability]', section);
    const error = q('[data-product-error]', form);
    function updateVariant(event) {
      const selected = inputs.map((group, index) => {
        const checked = q('input:checked', group);
        const span = q(`[data-option-label="${index}"]`, section);
        if (span) span.textContent = checked?.value || '';
        return checked?.value;
      });
      let variant = variants.find(item => item.options.every((opt, i) => opt === selected[i])) || (inputs.length === 0 ? variants[0] : null);
      // A size must be deliberately selected. Never guess a shoe number when color changes.
      const colorIndex = Number(section.dataset.colorOptionIndex);
      const sizeIndex = Number(section.dataset.sizeOptionIndex);
      if ((!variant || !variant.available) && event?.target && sizeIndex >= 0 && colorIndex >= 0 && Number(event.target.closest('[data-option-index]')?.dataset.optionIndex) === colorIndex) {
        const sizeChecked = q('input:checked', inputs[sizeIndex]);
        if (sizeChecked && !variants.some(item => item.available && item.options[colorIndex] === selected[colorIndex] && item.options[sizeIndex] === sizeChecked.value)) {
          sizeChecked.checked = false;
          selected[sizeIndex] = undefined;
          variant = null;
        }
      }
      const chosenColor = colorIndex >= 0 ? selected[colorIndex] : '';
      const displayVariant = variant || variants.find(item => item.available && (colorIndex < 0 || item.options[colorIndex] === chosenColor)) || variants[0];
      if (sizeIndex >= 0 && inputs[sizeIndex]) {
        qa('input[type="radio"]', inputs[sizeIndex]).forEach(input => {
          input.disabled = !variants.some(v => v.available && v.options[sizeIndex] === input.value && (colorIndex < 0 || v.options[colorIndex] === chosenColor));
        });
      }
      inputs.forEach((group, index) => { const display = q(`[data-option-label="${index}"]`, section); if (display) display.textContent = q('input:checked', group)?.value || ''; });
      if (idField) idField.value = variant?.id || '';
      if (addButton) addButton.disabled = !variant?.available;
      if (label) label.textContent = variant?.available ? 'SEPETE EKLE' : (variant ? 'TÜKENDİ' : 'SEPETE EKLE');
      if (availability) availability.innerHTML = variant?.available ? '<span class="aqqa-stock-dot"></span>STOKTA' : (variant ? 'STOKTA YOK' : 'NUMARA SEÇİN');
      if (price && displayVariant) price.innerHTML = `<span>${money(displayVariant.price)}</span>${displayVariant.compare_at_price > displayVariant.price ? `<s>${money(displayVariant.compare_at_price)}</s>` : ''}`;
      const selectionLabel = q('[data-add-selection]', form);
      if (selectionLabel) selectionLabel.textContent = variant ? [sizeIndex >= 0 ? variant.options[sizeIndex] : '', colorIndex >= 0 ? variant.options[colorIndex] : ''].filter(Boolean).join(' / ').toLocaleUpperCase('tr-TR') : '';
      const installment = q('[data-aqqa-installments]', section);
      if (installment && displayVariant) {
        const count = Number(installment.dataset.count) || 3;
        const amount = q('[data-installment-amount]', installment);
        if (amount) amount.textContent = money(Math.round(displayVariant.price / count));
      }
      const promo = q('[data-product-campaign]', section);
      if (promo && displayVariant) {
        const percent = Number(promo.dataset.promoPercent) || 0;
        const priceLabel = q('[data-product-campaign-price]', promo);
        if (priceLabel) priceLabel.textContent = money(Math.round(displayVariant.price * (100 - percent) / 100));
      }
      const galleryVariant = variants.find(item => colorIndex >= 0 && item.options[colorIndex] === chosenColor);
      section.dispatchEvent(new CustomEvent('aqqa:variantchange', {detail:{variant, color:chosenColor, galleryVariantId:variant?.id || galleryVariant?.id}}));
      if (variant?.id && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState(null, '', url.toString());
      }
    }
    qa('input[type="radio"]', form).forEach(el => el.addEventListener('change', updateVariant));
    updateVariant();
    form.addEventListener('submit', async event => {
      if (!idField?.value || !addButton || addButton.disabled) { event.preventDefault(); return; }
      event.preventDefault();
      const original = label?.textContent || 'SEPETE EKLE';
      addButton.disabled = true;
      if (label) label.textContent = 'EKLENİYOR...';
      if (error) { error.hidden = true;error.textContent = ''; }
      try {
        const response = await fetch(endpoint('cart/add.js'), {method:'POST',body:new FormData(form),credentials:'same-origin',headers:{'Accept':'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Ürün sepete eklenemedi.');
        await openDrawer();
      } catch (e) {
        if (error) { error.textContent = e.message || 'Ürün eklenemedi';error.hidden = false; }
      } finally {addButton.disabled = false;if (label) label.textContent = original;updateVariant();}
    });
    q('[data-size-guide-open]', section)?.addEventListener('click', () => q('[data-size-guide]', section)?.showModal());
    q('[data-size-guide-close]', section)?.addEventListener('click', () => q('[data-size-guide]', section)?.close());
    });
  }
  initializeProductSections();
  document.addEventListener('shopify:section:load', initializeProductSections);
})();
